import { PAGE_TYPES } from 'ai/analytics/events';
import { buildLyraAdviceField } from 'ai/utils/lyraAdviceCache';

export function buildPageContextFields(pageContext = {}) {
    const {
        pageType, productId, categoryId, categorySeoName, searchTerm
    } = pageContext;
    const fields = {};

    if (pageType === PAGE_TYPES.PRODUCT && productId) {
        fields.sotV15 = productId;
    } else if (pageType === PAGE_TYPES.CATEGORY && categoryId) {
        fields.sotV08 = categoryId;

        if (categorySeoName) {
            fields.sotV163 = categorySeoName;
        }
    } else if (pageType === PAGE_TYPES.SEARCH && searchTerm) {
        fields.sotV104 = searchTerm;
    }

    return fields;
}

export function buildPromptFields(promptText, messageId, previousMessageId) {
    const fields = {
        sotV402: promptText
    };

    if (messageId) {
        fields.sotV403 = messageId;
    }

    if (previousMessageId) {
        fields.sotV404 = previousMessageId;
    }

    return fields;
}

export function buildImpressionFields(prompts, delayMs = 1000) {
    const promptsString =
        Array.isArray(prompts) && prompts.length > 0
            ? prompts
                .map(p => p?.content || '')
                .filter(Boolean)
                .join(';')
            : '';

    return {
        sotV312: 'SuperChatView',
        sotV219: String(delayMs),
        sotV402: promptsString
    };
}

export function buildSentimentChipFields({ value, position, type }) {
    if (!value || !position) {
        return {};
    }

    const proOrCon = type === 'pros' ? 'Pro' : 'Con';

    return { sotV451: `${value};${position};${proOrCon}` };
}

export function buildLyraAdviceFields() {
    const lyraAdvice = buildLyraAdviceField();

    if (!lyraAdvice) {
        return {};
    }

    return { sotV03: lyraAdvice };
}

export function buildShadeFinderProductFields({
    sessionId, messageId, productId, productName, brandName
}) {
    const fields = {};

    if (sessionId) {
        fields.sotV450 = sessionId;
    }

    if (messageId) {
        fields.sotV403 = messageId;
    }

    if (productId) {
        fields.sotV15 = productId;
    }

    if (productName) {
        fields.sotV215 = productName;
    }

    if (brandName) {
        fields.sotV07 = brandName;
    }

    return fields;
}

export function buildShadeFinderShadeFields({
    sessionId, messageId, skuId, shadeCode, productId
}) {
    const fields = {};

    if (sessionId) {
        fields.sotV450 = sessionId;
    }

    if (messageId) {
        fields.sotV403 = messageId;
    }

    if (skuId) {
        fields.sotV04 = skuId;
    }

    if (shadeCode) {
        fields.sotV180 = shadeCode;
    }

    if (productId) {
        fields.sotV15 = productId;
    }

    return fields;
}

export function buildProductStrings(skuId, options = {}) {
    const { includeContext = true, basketType = 'standard' } = options;

    if (includeContext) {
        return `;${skuId};;;;eVar26=${skuId}|eVar23=superchat|eVar72=superchat|eVar133=${basketType}`;
    }

    return `;${skuId};;;;eVar26=${skuId}`;
}
